<template>
  <div id="affiliate-program">

    <banner>
      <router-link class="pure-color-btn" :to="redirectUrl">{{ $t('becomeMember') }}</router-link>
    </banner>

    <div class="advantage-component max-text-width">
      <advantage></advantage>
    </div>

    <join-step class="max-text-width"></join-step>

    <div id="become-affiliate" class="max-text-width">
      <commission-amount>
        <div class="gradient-border-btn">
          <router-link tag="button" :to="redirectUrl">
            {{ $t('becomeMember') }}
          </router-link>
        </div>
      </commission-amount>
    </div>

  </div>
</template>

<script>
  import Banner from '../../components/affiliateProgram/banner/Banner.vue'
  import Advantage from '../../components/affiliateProgram/advantage/Advantage.vue'
  import JoinStep from '../../components/affiliateProgram/joinStep/JoinStep.vue'
  import CommissionAmount from '../../components/affiliateProgram/commissionAmount/commissionAmount.vue'
  import locales from './lang'
  import { mapState } from 'vuex'

  export default {
    name: 'affiliate-program',
    components: {
      Banner, Advantage, JoinStep, CommissionAmount
    },
    locales,
    data() {
      return {
        isIE11: false
      }
    },
    computed: {
      ...mapState({
        commissionApplyStatus: state => state.commission.commissionApplyStatus,
        user: state => state.user
      }),
      redirectUrl() {
        if (!this.user.id) {
          return '/login?redirect_to=affiliate-program'
        } else if (this.commissionApplyStatus === 'complete') {
          return '/commission'
        } else {
          return '/become-an-affiliate'
        }
      }
    },
    mounted() {
      this.isIE11 = navigator.userAgent.indexOf('Trident') > -1
      this.$store.commit('isSpecialHeader', true)
      this.$store.commit('getdownload', false)
      let anchorId = this.$route.query.anchorId
      let anchorElement = document.getElementById(anchorId)

      if (anchorElement) {
        setTimeout(() => {
          document.body.scrollTop = anchorElement.offsetTop - 120
          document.documentElement.scrollTop = anchorElement.offsetTop - 120
        }, 100)
      }
      this.$store.dispatch('getCommissionApplyStatus')
    },
    destroyed() {
      this.$store.commit('isSpecialHeader', false)
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../assets/scss/variables";
  @import "../../assets/scss/mixins/button";
  @import "../../assets/scss/mixins/gradient";

  $max-text-width: 11.8rem;

  * {
    padding: 0;
    margin: 0;
  }

  .max-text-width {
    max-width: $max-text-width;
    margin: 0 auto;
  }

  #affiliate-program {
    min-height: 100vh;
  }

  .pure-color-btn {
    display: block;
    width: 350px;
    height: 66px;
    line-height: 66px;
    background-image: linear-gradient(125deg, #416CF8 0%, #EC55FF 100%);
    border-radius: 100px;
    font-size: 24px;
    color: #FFFFFF;
    text-align: center;
    font-weight: 600;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      top: 4px;
      left: 0;
      width: 100%;
      height: 100%;
      background-image: linear-gradient(125deg, #416cf8 0%, #ec55ff 100%);
      border-radius: 100px;
      filter: blur(4px);
      -webkit-filter: blur(4px);
      -moz-filter: blur(4px);
      -ms-filter: blur(4px);
      -o-filter: blur(4px);
      z-index: -1;
    }
  }

  .gradient-border-btn {
    font-size: 0;
    position: relative;
    margin-top: .32rem;
    text-align: center;
    button {
      display: inline-block;
      width: 350px;
      height: 66px;
      line-height: 66px;
      background-image: linear-gradient(125deg, #416CF8 0%, #EC55FF 100%);
      border-radius: 100px;
      font-size: 24px;
      color: #FFFFFF;
      text-align: center;
      font-weight: 600;
      border: none;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        top: 4px;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: linear-gradient(125deg, #416cf8 0%, #ec55ff 100%);
        border-radius: 100px;
        filter: blur(4px);
        -webkit-filter: blur(4px);
        -moz-filter: blur(4px);
        -ms-filter: blur(4px);
        -o-filter: blur(4px);
        z-index: -1;
      }
    }
  }

  @media (max-width: 1228px) {
    #affiliate-program {
      padding: 0 24px;
    }
  }

  @media (max-width: 911px) {
    .pure-color-btn {
      margin: 0 auto;
      width: 260px;
      height: 49px;
      line-height: 49px;
      font-size: 16px;
    }
  }
  
  @media (max-width: 820px) {
    .gradient-border-btn {
      margin-top: 41px;
      button {
        width: 260px;
        height: 49px;
        line-height: 49px;
        font-size: 16px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Index.vue?f5a45628